import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { OwlOptions } from "ngx-owl-carousel-o";
import { BaseService } from "../base.service";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-partner-content-detail",
  templateUrl: "./partner-content-detail.component.html",
  styleUrls: ["./partner-content-detail.component.css"],
})
export class PartnerContentDetailComponent implements OnInit {
  constructor(public service: BaseService, private route: ActivatedRoute) {}
  appConstant: any;
  data: any = [];
  img: any;
  simmerStatus = true;
  apiParam = {
    slug: "",
    limit: 20,
    offset: 0,
    feature: false,
    banner: false,
    id: "",
  };
  partnerData = [];
  name: any;
  ngOnInit(): void {
    this.appConstant = environment;
    window.scrollTo(0, 0);
    this.route.params.subscribe((params) => {
      this.apiParam.id = params.id;
    });
    this.route.queryParamMap.subscribe((params: any) => {
      this.data =[]
      this.partnerData = []
      if (params.params.slug) {
        this.apiParam.slug = params.params.slug;
        this.partnerDeail();
      }else{
        this.apiParam.slug=''
        this.partnerDeail();
      }
    });
  }
  watching: OwlOptions = {
    loop: false,
    autoplay: false,
    mouseDrag: true,
    autoWidth: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    smartSpeed: 1,
    skip_validateItems: true,
    navText: ["", ""],
    responsive: {
      0: {
        items: 3.5,
      },
      380: {
        items: 3.5,
      },
      450: {
        items: 4.5,
      },
      650: {
        items: 4.5,
      },
      910: {
        items: 4.2,
      },
      1108: {
        items: 4.2,
      },
      1230: {
        items: 5.2,
      },
      1257: {
        items: 5.2,
      },
    },
    nav: true,
  };
  playOff() {
    this.service.modelData = undefined;
    this.service.playerReady = false;
  }

  partnerDeail() {
    this.service.categoryData(this.apiParam).subscribe(
      (data: any) => {
        this.data = data;
        if (this.data.subcategory.length > 0) {
          this.partnerData = this.partnerData.concat(this.data.subcategory);
          this.simmerStatus = false;
        } else {
          this.simmerStatus = false;
        }
      },
      (err) => {
        if (err) {
          this.simmerStatus = false;
        }
      }
    );
  }
}
